/* eslint-disable @typescript-eslint/no-unsafe-return */
import {
  MetricDataProperty,
  MetricProperty,
  MetricSign,
  MetricType,
} from '../../recovery/component/recovery-metrics-panel/entity/DefaultMetric';
import { CompanyMetric } from './CompanyMetric';
import { UUID } from '../../../core/pojo/id-variable';
import { MetricGroup } from './MetricGroup';

export class Metric {
  uuid: string;
  name: string;
  priority = 1;
  props: MetricProperty;
  dataProps: MetricDataProperty;
  // For a company view, there is always 1 company metric. (filtered by backend)
  // For an org view, metric has relation to each org company, so there will be e.x. 5 company metrics
  companyMetrics: CompanyMetric[];

  static deserializeMetric(object: any): Metric {
    return Object.assign(new Metric(), object);
  }

  isStartingOrEnding(): boolean {
    return this.isStarting() || this.isEnding();
  }

  isStarting(): boolean {
    return this.props.type === MetricType.STARTING;
  }

  isEnding(): boolean {
    return this.props.type === MetricType.ENDING;
  }

  isRegular(): boolean {
    return this.props.type === MetricType.REGULAR;
  }

  isPositive(): boolean {
    return this.dataProps.sign === MetricSign.POSITIVE;
  }

  isNegative(): boolean {
    return this.dataProps.sign === MetricSign.NEGATIVE;
  }
}

export class MetricMini {
  uuid: UUID;
  name: string;
  groupName: string;
  groupUUID: UUID;

  static fromMetric(metric: Metric, metricGroup: MetricGroup): MetricMini {
    return {
      uuid: metric.uuid,
      name: metric.name,
      groupName: metricGroup.name,
      groupUUID: metricGroup.uuid,
    };
  }
}

export class MetricMiniWithCompanies {
  metric: MetricMini;
  companiesAmount: number | undefined;

  static fromMetric(metric: Metric, metricGroup: MetricGroup): MetricMiniWithCompanies {
    return {
      metric: MetricMini.fromMetric(metric, metricGroup),
      companiesAmount: undefined,
    };
  }
}

export class MetricDeleteResponseDto {
  companies: string[];
}

export class MetricGroupDeleteResponseDto {
  companies: string[];
}
